const TechnologyData = [
    {
      duration:1000,
      img: "/images/ReactJs-removebg-preview.png",
      name: "React JS"
    },
    {
      duration:1300,
      img: "/images/js.png",
      name: "JavaScript"
    },
    {
      duration:1600,
      img: "/images/MySQL_Server-removebg-preview.png",
      name: "MySQL"
    },
    {
      duration:1900,
      img: "/images/java-removebg-preview.png",
      name: "Java"
    },
    {
      duration:2400,
      img: "/images/python-removebg-preview.png",
      name: "Python"
    },
    
    {
      duration:2700,
      img: "/images/tailwindcss-removebg-preview (1).png",
      name: "TailWind"
    },
    {
      duration:3000,
      img: "/images/flask-removebg-preview.png",
      name: "Flask"
    },
    {
      duration:3000,
      img: "/images/mongo_img.png",
      name: "Mongo DB"
    },
    {
      duration:3000,
      img: "/images/node_img.png",
      name: "Node js"
    },

  ];
  
  export default TechnologyData;
  